import React from 'react';
import Pagination from "react-js-pagination";

const ContentPagination = (props) => {

  const {pagination, handlePageChange} = props
  const previousPage = pagination.hasPreviousPage ? pagination.pageIndex - 1 : null
  const nextPage = pagination.hasNextPage ? pagination.pageIndex + 1 : null
  
  return (
    <div id="PaginationContent">
      {!!previousPage &&
      <div
        className="prevPagination hasPage"
        onClick={() => handlePageChange(previousPage)}
      >
        <span className="prevArrow"/>
        <span className="prevArrow"/>
      </div>
      }

      <Pagination
        hideNavigation
        hideFirstLastPages
        activePage={pagination.pageIndex}
        itemsCountPerPage={pagination.pageSize}
        totalItemsCount={pagination.totalCount}
        onChange={handlePageChange}
      />
      {!!nextPage &&
      <div
        className="nextPagination hasPage"
        onClick={() => handlePageChange(nextPage)}
      >
        <span className="nextArrow"/>
        <span className="nextArrow"/>
      </div>
      }
    </div>
  );
};

export default ContentPagination;